import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal"
import { useEffect } from "react";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { EntregaObraClienteTermoForm, EntregaObraClienteTermoSchema } from "../../../schemas/entrega_obra_cliente_verificacao/entregaObraClienteTermoCadastro";

/**
 * EntregaObraTermoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  ddlTermos: DropDown[];

  onClose: () => void;
  onSubmit: (form: EntregaObraClienteTermoForm) => void;
};

export const EntregaObraTermoModal = ({
  open,
  saving,
  loading,
  ddlTermos,

  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<EntregaObraClienteTermoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(EntregaObraClienteTermoSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="40rem"
      title='Termos'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow" border={false} padding="small">
        <>
          <DefaultFormMultiAutocomplete
            name='idsTermo'
            label='Termos'
            required={true}
            options={ddlTermos}
            getOptionKey={x => x.id}
            getOptionLabel={x => x.title}
            reactHookForm={hookForm}
          />

        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}